// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import {
  calculateSavedPaymentAccountTransactionsResponseTransformer,
  getTransactionDetailsResponseTransformer,
  getTransactionsResponseTransformer,
  getTransferExchangeRateResponseTransformer,
  getWithdrawalRequestStatusResponseTransformer,
  saveWithdrawalRequestResponseTransformer,
} from "./transformers.gen";
import type {
  CalculateSavedPaymentAccountTransactionsData,
  CalculateSavedPaymentAccountTransactionsErrors,
  CalculateSavedPaymentAccountTransactionsResponses,
  CancelDepositTransactionData,
  CancelDepositTransactionErrors,
  CancelDepositTransactionResponses,
  CancelWithdrawalRequestData,
  CancelWithdrawalRequestErrors,
  CancelWithdrawalRequestResponses,
  CreateDocumentData,
  CreateDocumentErrors,
  CreateDocumentResponses,
  CreateSavedPaymentAccountData,
  CreateSavedPaymentAccountDeletionRequestByIdData,
  CreateSavedPaymentAccountDeletionRequestByIdErrors,
  CreateSavedPaymentAccountDeletionRequestByIdResponses,
  CreateSavedPaymentAccountErrors,
  CreateSavedPaymentAccountResponses,
  EmailVerifyWithdrawalRequestData,
  EmailVerifyWithdrawalRequestErrors,
  EmailVerifyWithdrawalRequestResponses,
  GetCashierV1AuthenticationLoginData,
  GetCashierV1AuthenticationLoginErrors,
  GetCashierV1AuthenticationOauthData,
  GetCashierV1AuthenticationOauthErrors,
  GetCashierV1AuthenticationOauthResponses,
  GetCashierV1AuthenticationVerifyData,
  GetCashierV1AuthenticationVerifyErrors,
  GetCashierV1AuthenticationVerifyResponses,
  GetCurrenciesData,
  GetCurrenciesErrors,
  GetCurrenciesResponses,
  GetDocumentByIdData,
  GetDocumentByIdErrors,
  GetDocumentByIdResponses,
  GetExchangeRateData,
  GetExchangeRateErrors,
  GetExchangeRateResponses,
  GetFreeMarginData,
  GetFreeMarginErrors,
  GetFreeMarginResponses,
  GetInternalCodesData,
  GetInternalCodesErrors,
  GetInternalCodesResponses,
  GetOrCreateCashierUserData,
  GetOrCreateCashierUserErrors,
  GetOrCreateCashierUserResponses,
  GetPageAlertData,
  GetPageAlertErrors,
  GetPageAlertResponses,
  GetPaymentMethodGroupByIdData,
  GetPaymentMethodGroupByIdErrors,
  GetPaymentMethodGroupByIdResponses,
  GetRawExchangeRateData,
  GetRawExchangeRateErrors,
  GetRawExchangeRateResponses,
  GetSavedPaymentAccountsProfitData,
  GetSavedPaymentAccountsProfitErrors,
  GetSavedPaymentAccountsProfitResponses,
  GetTradingAccountRefundBalanceData,
  GetTradingAccountRefundBalanceErrors,
  GetTradingAccountRefundBalanceResponses,
  GetTradingAccountsData,
  GetTradingAccountsErrors,
  GetTradingAccountsResponses,
  GetTransactionDetailsData,
  GetTransactionDetailsErrors,
  GetTransactionDetailsResponses,
  GetTransactionsData,
  GetTransactionsErrors,
  GetTransactionsResponses,
  GetTransactionStatusData,
  GetTransactionStatusErrors,
  GetTransactionStatusResponses,
  GetTransferExchangeRateData,
  GetTransferExchangeRateErrors,
  GetTransferExchangeRateResponses,
  GetWithdrawalRequestAmountData,
  GetWithdrawalRequestAmountErrors,
  GetWithdrawalRequestAmountResponses,
  GetWithdrawalRequestStatusData,
  GetWithdrawalRequestStatusErrors,
  GetWithdrawalRequestStatusResponses,
  HealthData,
  HealthResponses,
  InitSessionTokenData,
  InitSessionTokenErrors,
  InitSessionTokenResponses,
  InternalTransferConfirmData,
  InternalTransferConfirmErrors,
  InternalTransferConfirmResponses,
  InternalTransferCreateData,
  InternalTransferCreateErrors,
  InternalTransferCreateResponses,
  OtpVerifyWithdrawalRequestData,
  OtpVerifyWithdrawalRequestErrors,
  OtpVerifyWithdrawalRequestResponses,
  PaymentMethodsData,
  PaymentMethodsErrors,
  PaymentMethodsResponses,
  ResendEmailVerificationWithdrawalRequestData,
  ResendEmailVerificationWithdrawalRequestErrors,
  ResendEmailVerificationWithdrawalRequestResponses,
  SaveWithdrawalRequestData,
  SaveWithdrawalRequestErrors,
  SaveWithdrawalRequestResponses,
  StartTransactionData,
  StartTransactionErrors,
  StartTransactionResponses,
  UpdateCardExpiryDateData,
  UpdateCardExpiryDateErrors,
  UpdateCardExpiryDateResponses,
  UpdateDocumentStatusByIdData,
  UpdateDocumentStatusByIdErrors,
  UpdateDocumentStatusByIdResponses,
  UpdateTransactionData,
  UpdateTransactionErrors,
  UpdateTransactionResponses,
  VersionData,
  VersionErrors,
  VersionResponses,
  WithdrawalPaymentMethodsData,
  WithdrawalPaymentMethodsErrors,
  WithdrawalPaymentMethodsResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * PNX Cashier Service health check
 */
export const health = <ThrowOnError extends boolean = false>(
  options?: Options<HealthData, ThrowOnError>
) =>
  (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({
    url: "/__health__",
    ...options,
  });

/**
 * PNX Cashier Service backend build commit hash and time
 */
export const version = <ThrowOnError extends boolean = false>(
  options?: Options<VersionData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    VersionResponses,
    VersionErrors,
    ThrowOnError
  >({ url: "/cashier/__version__", ...options });

/**
 * Customer login
 */
export const getCashierV1AuthenticationLogin = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCashierV1AuthenticationLoginData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    unknown,
    GetCashierV1AuthenticationLoginErrors,
    ThrowOnError
  >({ url: "/cashier/v1/authentication/login", ...options });

/**
 * OAuth2 callback for customer
 */
export const getCashierV1AuthenticationOauth = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCashierV1AuthenticationOauthData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCashierV1AuthenticationOauthResponses,
    GetCashierV1AuthenticationOauthErrors,
    ThrowOnError
  >({ url: "/cashier/v1/authentication/oauth", ...options });

/**
 * Verify an customer Auth0 token
 */
export const getCashierV1AuthenticationVerify = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCashierV1AuthenticationVerifyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCashierV1AuthenticationVerifyResponses,
    GetCashierV1AuthenticationVerifyErrors,
    ThrowOnError
  >({ url: "/cashier/v1/authentication/verify", ...options });

/**
 * Get or create customer data
 */
export const getOrCreateCashierUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrCreateCashierUserData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetOrCreateCashierUserResponses,
    GetOrCreateCashierUserErrors,
    ThrowOnError
  >({ url: "/cashier/v1/authentication/user-data", ...options });

/**
 * Create a transaction to transfer funds between two internal trading accounts
 */
export const internalTransferCreate = <ThrowOnError extends boolean = false>(
  options?: Options<InternalTransferCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    InternalTransferCreateResponses,
    InternalTransferCreateErrors,
    ThrowOnError
  >({
    url: "/transfer/v1/create",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Confirm a transaction to transfer funds between two internal trading accounts
 */
export const internalTransferConfirm = <ThrowOnError extends boolean = false>(
  options?: Options<InternalTransferConfirmData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    InternalTransferConfirmResponses,
    InternalTransferConfirmErrors,
    ThrowOnError
  >({
    url: "/transfer/v1/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Upon receiving a series of standardized inputs (ISO, license names etc) this endpoint returns with their corresponding internal representations while also verifying their existance.
 */
export const getInternalCodes = <ThrowOnError extends boolean = false>(
  options: Options<GetInternalCodesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetInternalCodesResponses,
    GetInternalCodesErrors,
    ThrowOnError
  >({ url: "/cashier/v1/internal-codes", ...options });

/**
 * Get all transactions for a customer.
 * This method should be used in the cashier page to display the transaction history for the user.
 * It returns all types of transactions (deposit, withdrawal, internal transfer) for the user sorted by creation date, newest first.
 *
 */
export const getTransactions = <ThrowOnError extends boolean = false>(
  options?: Options<GetTransactionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetTransactionsResponses,
    GetTransactionsErrors,
    ThrowOnError
  >({
    responseTransformer: getTransactionsResponseTransformer,
    url: "/cashier/v1/transactions",
    ...options,
  });

/**
 * Get transaction details. This method is used in the cashier history page to display the transaction details and timeline for the customer.
 *
 */
export const getTransactionDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetTransactionDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTransactionDetailsResponses,
    GetTransactionDetailsErrors,
    ThrowOnError
  >({
    responseTransformer: getTransactionDetailsResponseTransformer,
    url: "/cashier/v1/transactions/{paymentType}/{referenceID}",
    ...options,
  });

/**
 * Get transaction status
 *
 * Get status of a specific transaction by reference ID and payment type (either deposit or withdrawal). Intended to be used after a transaction was executed to get information about the final balance and the status of the transaction. Returns the latest status of the transaction.
 */
export const getTransactionStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetTransactionStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTransactionStatusResponses,
    GetTransactionStatusErrors,
    ThrowOnError
  >({ url: "/cashier/v1/transactions/{referenceID}/status", ...options });

/**
 * Get exchange rate receives a pair of currency id along with an amount representing the convertable amount and returns the converted amount along with the used rate. This endpoint is used to determine the displayed amounts within the cashier page when the processing currency does not match the trading currency of the customer. The endpoint also expects various user related parameters in order to determine the appropriate fees and rounding settings that should be applied to the given user cohort.
 */
export const getExchangeRate = <ThrowOnError extends boolean = false>(
  options: Options<GetExchangeRateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetExchangeRateResponses,
    GetExchangeRateErrors,
    ThrowOnError
  >({ url: "/cashier/v1/exchange-rate", ...options });

/**
 * Get raw exchange rate receives a pair of currency id along with an amount representing the convertable amount and returns the converted amount along with the used rate. It does not take user parameters into account, only passes the value to the appropriate exchange rate API (based on whether they are fiat or crypto). It is used within the internal transfer page where the various cashier settings are irrelevant.
 */
export const getRawExchangeRate = <ThrowOnError extends boolean = false>(
  options: Options<GetRawExchangeRateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetRawExchangeRateResponses,
    GetRawExchangeRateErrors,
    ThrowOnError
  >({ url: "/cashier/v1/raw-exchange-rate", ...options });

/**
 * Get transfer exchange rate receives a pair of currency IDs along with transfer "from amount" and returns a calculated exchange fee, target amount, and a timestamp to set the expiry of the rate.
 */
export const getTransferExchangeRate = <ThrowOnError extends boolean = false>(
  options: Options<GetTransferExchangeRateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTransferExchangeRateResponses,
    GetTransferExchangeRateErrors,
    ThrowOnError
  >({
    responseTransformer: getTransferExchangeRateResponseTransformer,
    url: "/transfer/v1/exchange-rate",
    ...options,
  });

/**
 * Get trading accounts sorted by free margin (descending, normalized to AUD)
 */
export const getTradingAccounts = <ThrowOnError extends boolean = false>(
  options?: Options<GetTradingAccountsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetTradingAccountsResponses,
    GetTradingAccountsErrors,
    ThrowOnError
  >({ url: "/transfer/v1/trading-accounts", ...options });

/**
 * Get all available currencies
 */
export const getCurrencies = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrenciesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCurrenciesResponses,
    GetCurrenciesErrors,
    ThrowOnError
  >({ url: "/cashier/v1/currencies", ...options });

/**
 * Get the last active page alert for the cashier page
 */
export const getPageAlert = <ThrowOnError extends boolean = false>(
  options?: Options<GetPageAlertData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetPageAlertResponses,
    GetPageAlertErrors,
    ThrowOnError
  >({ url: "/cashier/v1/page-alert", ...options });

/**
 * Update card expiry date (format is MM/YY)
 */
export const updateCardExpiryDate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCardExpiryDateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateCardExpiryDateResponses,
    UpdateCardExpiryDateErrors,
    ThrowOnError
  >({
    url: "/cashier/v1/saved-payment-accounts/{savedPaymentAccountID}/card-expiry-date",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Start a deposit transaction
 *
 * Starts the transaction. The endpoint will not only register a transaction entry in the system but attempts to execute it directly with the payment service provider. The endpoint should be used by the customer when hitting deposit on the payment provider of their choice, and ideally should execute the entire deposit flow with no human interaction.
 */
export const startTransaction = <ThrowOnError extends boolean = false>(
  options: Options<StartTransactionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    StartTransactionResponses,
    StartTransactionErrors,
    ThrowOnError
  >({
    url: "/deposit/v1/start-transaction",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update SavedPaymentAccount and fail the transaction if BIN is blocked
 */
export const updateTransaction = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTransactionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateTransactionResponses,
    UpdateTransactionErrors,
    ThrowOnError
  >({
    url: "/deposit/v1/transactions/{referenceID}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Cancel a deposit transaction that has been started by the customer but not yet finalised by the PSP
 */
export const cancelDepositTransaction = <ThrowOnError extends boolean = false>(
  options: Options<CancelDepositTransactionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CancelDepositTransactionResponses,
    CancelDepositTransactionErrors,
    ThrowOnError
  >({ url: "/deposit/v1/transactions/{referenceID}/cancellation", ...options });

/**
 * Get payment methods
 *
 * Get payment methods available for a customer
 */
export const paymentMethods = <ThrowOnError extends boolean = false>(
  options: Options<PaymentMethodsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    PaymentMethodsResponses,
    PaymentMethodsErrors,
    ThrowOnError
  >({ url: "/deposit/v1/payment-methods", ...options });

/**
 * Get withdrawal payment methods
 *
 * Get withdrawal payment methods available for a customer
 */
export const withdrawalPaymentMethods = <ThrowOnError extends boolean = false>(
  options: Options<WithdrawalPaymentMethodsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WithdrawalPaymentMethodsResponses,
    WithdrawalPaymentMethodsErrors,
    ThrowOnError
  >({ url: "/withdrawal/v1/payment-methods/{tradingAccountID}", ...options });

/**
 * Get details of a given payment method group
 */
export const getPaymentMethodGroupById = <ThrowOnError extends boolean = false>(
  options: Options<GetPaymentMethodGroupByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPaymentMethodGroupByIdResponses,
    GetPaymentMethodGroupByIdErrors,
    ThrowOnError
  >({
    url: "/deposit/v1/payment-method-groups/{paymentMethodGroupID}",
    ...options,
  });

/**
 * Create a deletion request for a saved payment account
 */
export const createSavedPaymentAccountDeletionRequestById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateSavedPaymentAccountDeletionRequestByIdData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    CreateSavedPaymentAccountDeletionRequestByIdResponses,
    CreateSavedPaymentAccountDeletionRequestByIdErrors,
    ThrowOnError
  >({
    url: "/deposit/v1/saved-payment-accounts/{savedPaymentAccountID}/deletion-request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get withdrawal request amount
 *
 * Get amount of a specific withdrawal request by reference ID
 */
export const getWithdrawalRequestAmount = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetWithdrawalRequestAmountData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWithdrawalRequestAmountResponses,
    GetWithdrawalRequestAmountErrors,
    ThrowOnError
  >({
    url: "/withdrawal/v1/requests/{withdrawalRequestID}/amount",
    ...options,
  });

/**
 * Returns the available funds in the trading account
 */
export const getTradingAccountRefundBalance = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTradingAccountRefundBalanceData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTradingAccountRefundBalanceResponses,
    GetTradingAccountRefundBalanceErrors,
    ThrowOnError
  >({
    url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/refund",
    ...options,
  });

/**
 * Initiate session token for customer
 *
 * Get a session token for WEB SDK to use a saved payment account for a trading account by the CustomerID.
 */
export const initSessionToken = <ThrowOnError extends boolean = false>(
  options: Options<InitSessionTokenData, ThrowOnError>
) =>
  (options.client ?? client).get<
    InitSessionTokenResponses,
    InitSessionTokenErrors,
    ThrowOnError
  >({
    url: "/cashier/v1/trading-accounts/{tradingAccountID}/payment-methods/{paymentMethodID}/session",
    ...options,
  });

/**
 * Create a saved payment account for a trading account.
 */
export const createSavedPaymentAccount = <ThrowOnError extends boolean = false>(
  options: Options<CreateSavedPaymentAccountData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateSavedPaymentAccountResponses,
    CreateSavedPaymentAccountErrors,
    ThrowOnError
  >({
    url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/payment-methods/{paymentMethodID}/saved-payment-accounts/create",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get all saved payment accounts available to withdraw profit
 */
export const getSavedPaymentAccountsProfit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSavedPaymentAccountsProfitData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSavedPaymentAccountsProfitResponses,
    GetSavedPaymentAccountsProfitErrors,
    ThrowOnError
  >({
    url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/saved-payment-accounts/profit",
    ...options,
  });

/**
 * Update Document Status by ID
 */
export const updateDocumentStatusById = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDocumentStatusByIdData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateDocumentStatusByIdResponses,
    UpdateDocumentStatusByIdErrors,
    ThrowOnError
  >({
    url: "/cashier/v1/documents/{documentID}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a withdrawal request
 *
 * Recalculate and save transactions for a withdrawal request
 */
export const saveWithdrawalRequest = <ThrowOnError extends boolean = false>(
  options: Options<SaveWithdrawalRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SaveWithdrawalRequestResponses,
    SaveWithdrawalRequestErrors,
    ThrowOnError
  >({
    responseTransformer: saveWithdrawalRequestResponseTransformer,
    url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Verify the withdrawal using an MFA code. Call this endpoint after the user has successfully completed two-factor authentication (2FA).
 */
export const otpVerifyWithdrawalRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OtpVerifyWithdrawalRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OtpVerifyWithdrawalRequestResponses,
    OtpVerifyWithdrawalRequestErrors,
    ThrowOnError
  >({
    url: "/withdrawal/v1/requests/{withdrawalRequestID}/otp-verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Verify the withdrawal request using an email verification. Call this endpoint after the user has opened the verification link in their email. The `emailVerificationToken` query parameter is a secret token (distinct from the withdrawal request ID) that is only present in the verification email.
 */
export const emailVerifyWithdrawalRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<EmailVerifyWithdrawalRequestData, ThrowOnError>
) =>
  (options.client ?? client).get<
    EmailVerifyWithdrawalRequestResponses,
    EmailVerifyWithdrawalRequestErrors,
    ThrowOnError
  >({
    url: "/withdrawal/v1/requests/{withdrawalRequestID}/email-verify",
    ...options,
  });

/**
 * Cancel the withdrawal request. Call this endpoint to cancel a pending withdrawal request.
 */
export const cancelWithdrawalRequest = <ThrowOnError extends boolean = false>(
  options: Options<CancelWithdrawalRequestData, ThrowOnError>
) =>
  (options.client ?? client).get<
    CancelWithdrawalRequestResponses,
    CancelWithdrawalRequestErrors,
    ThrowOnError
  >({
    url: "/withdrawal/v1/requests/{withdrawalRequestID}/cancel",
    ...options,
  });

/**
 * Get the current status of a withdrawal request without mutating it.
 */
export const getWithdrawalRequestStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetWithdrawalRequestStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWithdrawalRequestStatusResponses,
    GetWithdrawalRequestStatusErrors,
    ThrowOnError
  >({
    responseTransformer: getWithdrawalRequestStatusResponseTransformer,
    url: "/withdrawal/v1/requests/{withdrawalRequestID}/status",
    ...options,
  });

/**
 * Resend the email verification for a withdrawal request. Call this endpoint to resend the verification email.
 */
export const resendEmailVerificationWithdrawalRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResendEmailVerificationWithdrawalRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ResendEmailVerificationWithdrawalRequestResponses,
    ResendEmailVerificationWithdrawalRequestErrors,
    ThrowOnError
  >({
    url: "/withdrawal/v1/requests/{withdrawalRequestID}/resend-email",
    ...options,
  });

/**
 * Calculate transactions based saved payment accounts withdraw details
 */
export const calculateSavedPaymentAccountTransactions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CalculateSavedPaymentAccountTransactionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CalculateSavedPaymentAccountTransactionsResponses,
    CalculateSavedPaymentAccountTransactionsErrors,
    ThrowOnError
  >({
    responseTransformer:
      calculateSavedPaymentAccountTransactionsResponseTransformer,
    url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/saved-payment-accounts/calculate-transactions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Document by ID
 */
export const getDocumentById = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDocumentByIdResponses,
    GetDocumentByIdErrors,
    ThrowOnError
  >({ url: "/cashier/v1/documents/{documentID}", ...options });

/**
 * Create a new document and get a presigned url. If the SPA ID is present, the document will be linked to the SPA. Otherwise, the document will be created without a link as a general upload for purposes like deletion request.
 */
export const createDocument = <ThrowOnError extends boolean = false>(
  options: Options<CreateDocumentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateDocumentResponses,
    CreateDocumentErrors,
    ThrowOnError
  >({
    url: "/cashier/v1/documents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Gets free margin amount by trading account ID
 */
export const getFreeMargin = <ThrowOnError extends boolean = false>(
  options: Options<GetFreeMarginData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFreeMarginResponses,
    GetFreeMarginErrors,
    ThrowOnError
  >({
    url: "/cashier/v1/trading-accounts/{tradingAccountID}/free-margin",
    ...options,
  });
